/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */
// baki
import React, { useState, useEffect, useContext } from 'react';
import Alert from 'react-s-alert';
import { Button, Modal, ModalHeader, ModalFooter, ModalBody, Label, Table, Progress } from 'reactstrap';
import moment from 'moment';

// context imports
import { ThemeContext } from '../../../contexts/ThemeContext';
import { AuthContext } from '../../../contexts/AuthContext';

// service imports
import GeneralService from '../../../services/GeneralService';

// local imports
import UserNotApproved from './UserNotApproved';
import ErrorBoundary from '../../general/ErrorBoundary';
import ProviderNavbar from './ProviderNavbar';
import ProviderService from '../../../services/ProviderService';
import Loading from '../../../assets/UW_Horizontal_Logo_Full.png';
import Arrow from '../../../assets/arrow.svg';
import FindProviderImg from '../../../assets/active_support.svg';

const CancelProviderSubscription = props => {

    // contexts
    const { theme, fontWeight, colors } = useContext(ThemeContext);
    const { user, setUser, selectedTimeZone, userApprovalStatus } = useContext(AuthContext);

    // states
    const [selectedProvider, setSelectedProvider] = useState(null);
    const [currentProviderSubscription, setCurrentProviderSubscription] = useState(null);
    const [cancelModal, setCancelModal] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);

    // useEffects

    useEffect(() => {
        try {
            if (props.location.state) {
                // console.log("states", props.location.state);
                setSelectedProvider(props.location.state.selectedProvider);
                setCurrentProviderSubscription(props.location.state.currentSubscription);
                setIsLoading(false);
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Provider MakeSubscriptionPayment useEffect2', 'Error in try catch block', err.stack);
        }
    }, [props.location.state]);

    // handle functions
    const handleCancelPlan = e => {
        try {
            setDisableSubmitBtn(true);
            try {
                ProviderService.cancelProviderSubscription(currentProviderSubscription.razorpaySubscriptionId).then(data => {
                    // console.log("data", data);
                    setCancelModal(false);
                    setDisableSubmitBtn(false);
                    props.history.push('mysubscription');
                }).catch(err => {
                    console.log("err3", err);
                    setCancelModal(false);
                    setDisableSubmitBtn(false);
                    Alert.error("Some error occured, please try again later or report support team.", {
                        position: 'top-right',
                        effect: 'slide'
                    });
                });
            } catch (err) {
                console.log("err2", err);
                setCancelModal(false);
                setDisableSubmitBtn(false);
                Alert.error("Some error occured, please try again later or report support team.", {
                    position: 'top-right',
                    effect: 'slide'
                });
                // GeneralService.logError('at BookSession handleSubmit', err.stack);
            }
        } catch (err) {
            setCancelModal(false);
            setDisableSubmitBtn(false);
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // GeneralService.logError('at BookSession handleSubmit', err.stack);
        }
    }

    // function's return
    return (
        <div>
            <ProviderNavbar history={props.history} />
            {
                isLoading ?
                    <img className="mx-auto d-block" height="auto" width="40%" src={Loading} alt="Loading..." />
                    :
                    userApprovalStatus ?
                        <div className="p-2">
                            <div>
                                <div className="text-center">
                                    <h1 style={{ fontFamily: "Montserrat, sans-serif", fontSize: "1.8rem", fontWeight: "500", color: "#384E73" }}>Cancel Current Plan</h1>
                                    <h2 style={{ fontFamily: "Montserrat, sans-serif", fontSize: "1.2rem", fontWeight: "500" }}>Your existing plan will be cancelled.<br />You will be able to use your existing plan benefits till end of the cycle.</h2>
                                </div>
                                <div className="pt-4" style={{ fontWeight: "500" }}>Current Subscription Plan Details</div>
                                <hr />
                                <Table borderless>
                                    <tbody>
                                        <tr>
                                            <td style={{ width: '30%' }}>
                                                <span style={{ fontWeight: fontWeight.medium }}>Subscription Plan</span>
                                            </td>
                                            <td>
                                                <span>{currentProviderSubscription.name}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span style={{ fontWeight: fontWeight.medium }}>Sessions</span>
                                            </td>
                                            <td className="d-flex">
                                                <Progress className="successProgress my-auto mr-2" value={(100 * currentProviderSubscription.subscriptionCycle[currentProviderSubscription.subscriptionCycle.length - 1].serviceDetails.sessionBookingCount) / currentProviderSubscription.subscriptionCycle[currentProviderSubscription.subscriptionCycle.length - 1].serviceDetails.sessionBookingLimit} /><span>{`${currentProviderSubscription.subscriptionCycle[currentProviderSubscription.subscriptionCycle.length - 1].serviceDetails.sessionBookingCount}/${currentProviderSubscription.subscriptionCycle[currentProviderSubscription.subscriptionCycle.length - 1].serviceDetails.sessionBookingLimit}`}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span style={{ fontWeight: fontWeight.medium }}>Clients</span>
                                            </td>
                                            <td className="d-flex">
                                                <Progress className="successProgress my-auto mr-2" value={(100 * currentProviderSubscription.subscriptionCycle[currentProviderSubscription.subscriptionCycle.length - 1].serviceDetails.clientCount) / currentProviderSubscription.subscriptionCycle[currentProviderSubscription.subscriptionCycle.length - 1].serviceDetails.clientLimit} /><span>{`${currentProviderSubscription.subscriptionCycle[currentProviderSubscription.subscriptionCycle.length - 1].serviceDetails.clientCount}/${currentProviderSubscription.subscriptionCycle[currentProviderSubscription.subscriptionCycle.length - 1].serviceDetails.clientLimit}`}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span style={{ fontWeight: fontWeight.medium }}>Call Sessions</span>
                                            </td>
                                            <td className="d-flex">
                                                <span><i className={`fas fa-${currentProviderSubscription.subscriptionCycle[currentProviderSubscription.subscriptionCycle.length - 1].serviceDetails.modeOfServices.call ? 'check' : 'times danger_text_color'}`}></i></span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span style={{ fontWeight: fontWeight.medium }}>Video Sessions</span>
                                            </td>
                                            <td className="d-flex">
                                                <span><i className={`fas fa-${currentProviderSubscription.subscriptionCycle[currentProviderSubscription.subscriptionCycle.length - 1].serviceDetails.modeOfServices.video ? 'check' : 'times danger_text_color'}`}></i></span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span style={{ fontWeight: fontWeight.medium }}>In Person Sessions</span>
                                            </td>
                                            <td className="d-flex">
                                                <span><i className={`fas fa-${currentProviderSubscription.subscriptionCycle[currentProviderSubscription.subscriptionCycle.length - 1].serviceDetails.modeOfServices.inPerson ? 'check' : 'times danger_text_color'}`}></i></span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span style={{ fontWeight: fontWeight.medium }}>Messaging</span>
                                            </td>
                                            <td className="d-flex">
                                                <span><i className={`fas fa-${currentProviderSubscription.subscriptionCycle[currentProviderSubscription.subscriptionCycle.length - 1].serviceDetails.modeOfServices.chat ? 'check' : 'times danger_text_color'}`}></i></span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span style={{ fontWeight: fontWeight.medium }}>Create Subscription Plans</span>
                                            </td>
                                            <td className="d-flex">
                                                <span><i className={`fas fa-${currentProviderSubscription.subscriptionCycle[currentProviderSubscription.subscriptionCycle.length - 1].serviceDetails.createClientSubscriptionPlans ? 'check' : 'times danger_text_color'}`}></i></span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span style={{ fontWeight: fontWeight.medium }}>Start Date</span>
                                            </td>
                                            <td>
                                                <span>{moment(currentProviderSubscription.subscriptionCycle[currentProviderSubscription.subscriptionCycle.length - 1].startDate).format("MMM DD, dddd, YYYY")}</span>
                                            </td>
                                        </tr>
                                        {/* <tr>
                                        <td>
                                            <span style={{ fontWeight: fontWeight.medium }}>Next Payment Date</span>
                                        </td>
                                        <td>
                                            <span>{currentProviderSubscription.isCancelled ? "-" : moment(currentProviderSubscription.subscriptionCycle[currentProviderSubscription.subscriptionCycle.length - 1].nextChargeAt).format("MMM DD, dddd")}</span>
                                        </td>
                                    </tr> */}
                                        <tr>
                                            <td>
                                                <span style={{ fontWeight: fontWeight.medium }}>Days Passed</span>
                                            </td>
                                            <td className="d-flex">
                                                <Progress className="successProgress my-auto mr-2" value={(100 * currentProviderSubscription.currentCycleDaysGone) / currentProviderSubscription.currentCycleTotalDays} /><span>{`${currentProviderSubscription.currentCycleDaysGone}/${currentProviderSubscription.currentCycleTotalDays}`}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                                <div>
                                    <button className="btn mx-auto mt-4" id="paymentBtn" type="button" style={theme.buttonDanger} disabled={disableSubmitBtn} onClick={() => setCancelModal(true)}>
                                        {disableSubmitBtn ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Cancel Plan
                                    </button>
                                </div>
                                <br />
                                <text>*Subscription will be cancelled at the end of current cycle.</text>
                            </div>
                        </div>
                        :
                        <UserNotApproved />
            }
            <Modal size="lg" isOpen={cancelModal} backdrop={true}>
                <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setCancelModal(false)}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Cancel Plan</span></ModalHeader>
                <ModalBody>
                    <Label>By clicking on Continue button your subscription will be cancelled and you won't be charged about this in future.<br />You can still enjoy the benefits of the current subscription untill the current cycle ends.</Label>
                </ModalBody>
                <ModalFooter>
                    <Button type="button" style={theme.formButton} className="btn" disabled={disableSubmitBtn} onClick={() => handleCancelPlan()}>
                        {disableSubmitBtn ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Continue
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    )

}

export default CancelProviderSubscription;